import React from "react";
import HomeCard from "./HomeCard";
import {motion} from "framer-motion";
import {Pause, Play} from "lucide-react";

const HomeActiveSeries = ({activeSeries, handleSeriesAction}) => {
    return (
        <HomeCard>
            <h3 className="text-2xl font-semibold mb-6 text-gray-800">Active Series</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {activeSeries.map((one, index) => (
                    <HomeCard   key={one._id}>
                        <h4 className="text-lg font-semibold mb-2 text-gray-800">{one.theme.theme}</h4>
                        <p className="text-sm text-gray-600 mb-4">{one.videos.length} shorts created</p>
                        <p className="text-sm text-gray-600 mb-4">Platforms: {one.platforms.join(', ')}</p>
                        <div className="flex items-center justify-between">
            <span className={`px-3 py-1 rounded-full text-xs font-medium ${one.status === 'Active' ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'}`}>
                {one.status.charAt(0).toUpperCase() + one.status.slice(1)}
            </span>
                            <motion.button
                                onClick={() => handleSeriesAction(one._id)}
                                whileHover={{ scale: 1.1 }}
                                whileTap={{ scale: 0.9 }}
                                className="p-2 rounded-full bg-gray-100 hover:bg-gray-200 transition-colors duration-300"
                            >
                                {one.status === 'Active' ? <Pause className="h-5 w-5 text-gray-600" /> : <Play className="h-5 w-5 text-gray-600" />}
                            </motion.button>
                        </div>
                    </HomeCard>
                ))}
            </div>
        </HomeCard>

    );
};

export default HomeActiveSeries;
